import { Timestamp, arrayUnion } from 'firebase/firestore';

import { findIndex, includes } from 'lodash-es';
import { IRunner, IShopOrder } from '@features/Orders/types';
import { IRouterStep } from '@shared/types/productionSchedule';
import { IBomItem, IOrderItem } from '@shared/types/dbRecords';
import { IConsumptionMeta } from '@shared/lib/data/inventory/adjustments';

import _ from 'lodash-es'

export const CONSTRUCTION_JASON = {
  stationId: 'McjyywD915d26qI63BQHoLAgoY82',
  stepId: '8itJFuQJVT0',
};
export const RELEASE_STATION = {
  stationId: 'thoqTZixlrhlYxWy52GHUvNUUr42',
  stepId: ['bIKQ9ANcC', 'ARft0FS3O'],
};

export const CNC_STATION_NECK = {
  stationId: '7l8NTrVLWFYReCmFYnbabqNXxTe2',
  stepdId: ['DXLLG0NQx', 'rAkvCIHRH6i'],
};

export const scanStation = (user: any) => {
  if (user.uid === RELEASE_STATION.stationId) return 'Release Station';
  if (user.uid === 'uuikiqzedJPiJ0t1zc9bJn2cDQt2') return 'Material Assembly';
  if (user.uid === 'n973nmDar7Xs7j74bmCJ8IcGlXp2') return 'Construction';
  if (user.uid === CONSTRUCTION_JASON.stationId) return 'Construction';
  if (user.uid === 'kF8mOZ8sIXXAOVPjFyJty8aFCfl1' || user.uid === 'gEmUhPcMPHeCYUCA8o0dEXdBoSo1') return 'Finishing';
  if (user.uid === 'fUl6oWOQOYSHxDkI9BVYzgi8suj1') return 'Dry Room';
  if (user.uid === CNC_STATION_NECK.stationId) return 'CNC';
  if (user.uid === 'mAmnJq0iJAUpSCZgKC5MIOEHrTD2') return 'QA / Shipping';
};

export const selectAudio = (currentUserId: string) => (
  currentUserId === RELEASE_STATION.stationId ? '/audio/beep.mp3' : '/audio/scan_success.mp3');

export const runnerHistory = (runner: IRunner, stationId: string) => {
  const history = runner.history || [];
  if (stationId === history[history.length - 1]?.step) return history;
  return [
    ...history,
    {
      dateEntered: Timestamp.fromDate(new Date()),
      step: stationId,
    },
  ];
};

export const updateAllRunners = (order: IShopOrder, stepId: string): [IRunner, IShopOrder] => {
  const runners = order.runners?.map((r: IRunner) => ({
    ...r,
    history: runnerHistory(r, stepId),
    step: stepId,
  }));

  const SO = {
    ...order,
    runners,
  };

  return [runners[0], SO];
};

/** @deprecated Replaced by consumeMaterials Cloud Function. Use consumeRunnerMaterials() from @shared/lib/consumption/consumeRunnerMaterials instead. Will be removed in a future version. */
export const updateRunnerBom = (r: IRunner, stepId: string, routerSteps: IRouterStep[], partType: 'neck'|'body'|'misc'): any => {
  const consumedParts: { [sku: string]: number } = {};
  const partConsumption: NonNullable<IConsumptionMeta['partConsumption']> = [];
  const orderTypeSteps = routerSteps.filter((step: IRouterStep) => step.type === partType);
  const endStep = findIndex(orderTypeSteps, (step: IRouterStep) => step.id === stepId);
  const consumptionSteps = orderTypeSteps.slice(0, endStep + 1).map((step: IRouterStep) => step.id);
  const updatedRunnerParts = r.parts.map((p: IOrderItem) => {
    const partMaterials: Array<{ sku: string; description: string; quantity: number }> = [];
    const bom = p.bom.map((b: IBomItem) => {
      // if the step the bom item is to be consumed at is in the consumption steps array,
      // consume the quantity of the part in the bom minus whatever has already been consumed.
      // this will effectively prevent overconsumption and make the quantity assigned the maximum consumable quantity
      const quantityNeeded = b.quantity * p.quantityAssigned;
      const needToConsume = quantityNeeded !== ((b as any).quantityConsumed || 0);
      let quantityConsumed = 0;
      if (includes(consumptionSteps, b.stepId)) {
        if (needToConsume) quantityConsumed = quantityNeeded - ((b as any).quantityConsumed || 0);
        else quantityConsumed = (b as any).quantityConsumed;
      }
      if (quantityConsumed > 0 && needToConsume) {
        if (includes(Object.keys(consumedParts), b.Sku)) {
          consumedParts[b.Sku] += quantityConsumed;
        } else {
          consumedParts[b.Sku] = quantityConsumed;
        }
        partMaterials.push({
          sku: b.Sku,
          description: b.description || b.Description,
          quantity: quantityConsumed,
        });
      }
      return {
        ...b,
        quantityConsumed: quantityConsumed ?? 0,
      };
    });
    if (partMaterials.length > 0) {
      partConsumption.push({
        partNumber: p.Sku || (p as any).partNumber || 'Unknown',
        partDescription: p.Description || 'Unknown Part',
        rawMaterials: partMaterials,
      });
    }
    return { ...p, bom };
  });
  return { updatedRunner: { ...r, parts: updatedRunnerParts }, consumedParts, partConsumption };
};

/** @deprecated Replaced by the runner-advancement logic inside the consumeMaterials Cloud Function. The CF atomically writes consumption records, inventory adjustments, and runner step/history updates. Will be removed in a future version. */
export const updateRunners = (order: IShopOrder, runner: IRunner, stepId: string): [IRunner, IShopOrder] => {
  // if this is the release scanner, update all runners at once, and return the first runner on the order.
  if (_.includes(['cIKQ9ANcC', 'fArt0FS3O'], stepId)) return updateAllRunners(order, stepId);

  const runnerIndex = _.findIndex(order.runners, (r: IRunner) => r.id === runner.id);
  const updatedRunner = { ...runner, history: runnerHistory(runner, stepId), step: stepId };

  const runners = [
    ...order.runners.slice(0, runnerIndex),
    updatedRunner,
    ...order.runners.slice(runnerIndex + 1),
  ];

  const SO = {
    ...order,
    runners,
  };

  return [updatedRunner, SO];
};
